import classnames from 'classnames';
import {Trans} from 'react-i18next';
import React, {useEffect, useState} from 'react';
import _isEmpty from 'lodash/isEmpty';
import Link from '../../../../link';
import ArrowIcon from '../ArrowIcon';
import pathUtils from '../../../../../utils/pathUtils';
import _get from 'lodash/get';

export default function ExpandableList({
  title,
  menus,
  list = [],
  closeMenu = () => {},
  setIndex = () => {},
  index,
  id,
}) {
  const [isExpand, setIsExpand] = useState(false);
  const isActive = path =>
    window.location.pathname === pathUtils.addLangPrefix(path);
  useEffect(() => {
    if (index !== id) setIsExpand(false);
  }, [index]);

  return (
    <div>
      <div
        className={classnames({
          'pf-header-mobile-business-menus__item': true,
          'pf-header-mobile-business-menus__item--opened': isExpand,
        })}
        onClick={() => {
          setIndex(id);
          setIsExpand(!isExpand);
        }}
      >
        {title}
        <ArrowIcon isShow={isExpand} color="grey" />
      </div>

      {menus && (
        <div style={{display: isExpand ? 'block' : 'none'}}>
          {/* pass closeMenu down so tapping an item collapses the whole mobile menu */}
          {React.isValidElement(menus)
            ? React.cloneElement(menus, {onClick: closeMenu})
            : menus}
        </div>
      )}
      {!menus &&
        !_isEmpty(list) &&
        list.map((m, i) => (
          <div
            key={'menu4-' + i}
            className={classnames({
              'pf-header-mobile-business-menus__subitem-category': true,
              'pf-header-mobile-business-menus__subitem-category-item--active': isActive(
                _get(m, 'link', '')
              ),
              'pf-header-mobile-business-menus--collapse': !isExpand,
            })}
          >
            <Link to={_get(m, 'link', '')} onClick={closeMenu}>
              {_get(m, 'text') || <Trans i18nKey={m.i18nKey} />}
            </Link>
          </div>
        ))}
    </div>
  );
}
